<template>
   <div class="zhenyun-agreement">
      <div class="zhenyun-agreement-title">协议管理</div>
      <div class="zhenyun-agreement-detail">
         <div class="detail-suggestion">
            <div class="head">
               <img src="@/assets/image/zhenyun/star.png" alt="">*解锁海智生态专区千万级订单资源！*报名参与海智生态专区 
               <a style="color: #0863FF;" @click="joinActive">【立即报名】</a>
               <i class="iconfont icon-jump" style="color: #0863FF;"></i>
            </div>
            <div class="tip">
               <p><i class="el-icon-warning-outline" style="color:#0863FF;;margin-right:8px;"></i>尊敬的海智供应商您好!</p>
               <p style="margin-left: 22px;">为保障生态合作合规性与数据安全，<span style="color: #222;font-weight:700;">所有参与海智生态合作伙伴订单专区的供应商，需预先签置由海智生态伙伴提供的《生态合作协议》。</span>
               </p>
               <p class="sales">咨询支持：{{ salesInfoClient.name }}&nbsp;&nbsp; {{ salesInfoClient.phone }}</p>
            </div>
         </div>
         <div class="detail-table">
            <el-table :data="list" style="width: 100%">
               <el-table-column prop="name" label="协议名称"></el-table-column>
               <el-table-column prop="provider" label="协议提供方"></el-table-column>
               <el-table-column prop="typeStr" label="协议类型"></el-table-column>
               <el-table-column prop="state" label="协议状态">
                  <template slot-scope="scope">
                     <span v-if="scope.row.state==10" class="status" style="background-color:#FF7800;"></span>
                     <span v-if="scope.row.state==20" class="status" style="background-color:#665DFF;"></span>
                     <span v-if="scope.row.state==30" class="status" style="background-color:#3B9AFF;"></span>
                     <!-- <span v-if="scope.row.state==40" class="status" style="background-color:#20B820;"></span> -->
                     <span>{{ scope.row.state==10? '待签署' : scope.row.state==20 ? '签署中': '已签署' }}</span>
                  </template>
               </el-table-column>
               <el-table-column label="操作">
                  <template slot-scope="scope">
                     <a 
                        v-if="scope.row.state==10"
                        @click="goSign(scope.row)"
                        style="display:inline-block;width:42px;margin-right: 12px;color:#0863FF;" 
                     >去签署</a> 
                     <a 
                        v-else
                        @click="goView(scope.row)"
                        style="display:inline-block;width:42px;margin-right: 12px;color:#0863FF;" 
                     >查看</a>
                     <!-- <a style="color:#0863FF;">
                        <i class="iconfont icon-AI"></i>
                        <span>合同摘要</span>
                     </a>  -->
                  </template>
               </el-table-column>
            </el-table>
         </div>
      </div>
      <ZhenYunServiceAgreement
         ref="orderSubmissionServiceAgreement"
         v-if="serviceAgreementShow"
         @close="serviceAgreementClose"
         :agreements="zhenyunAgreements"
         :index="agreementIndex"
         :zhenyunObj="zhenyunObj"
      />

      <ConcatManagerDialog
         v-if="concatDialogVisible" 
         :concatDialogVisible="concatDialogVisible"
         @closeConcatDialog="closeConcatDialog" 
      ></ConcatManagerDialog>
   </div>
</template>
<script>
import { 
   findIsAuthentication ,
   agreementList,
   agreementAuthorization,
   getAgreementDetail,
} from '@/utils/api/zhenyun-agreement.js';
import { mapState, mapMutations } from 'vuex'
import getAgreementMinxins from '@/mixins/getAgreement'
import ZhenYunServiceAgreement from '@/components/common/ZhenYunServiceAgreement'
import ConcatManagerDialog from "@/components/common/ConcatManagerDialog.vue";
import { handleFormatDate } from "@/utils/handle.js";
import {clientContact} from "@/utils/api/zhenyunOrder"

const AGENT_AGREEMENT_TYPE = 170

export default{
   mixins: [getAgreementMinxins],
   components: {
      ZhenYunServiceAgreement,
      ConcatManagerDialog
   },
   computed: {
    ...mapState('permissionVerification', ['accessData']),
    ...mapState('serviceAgreement', ['zhenyunAgreementList']),
    ...mapState(['userInfo']),
   },
   data(){
      return {
        salesInfoClient:{},
         authStatus: false,
         authCompName:"",
         authMobile:"",
         zhenyunAgreements: [],
         agreementIndex: undefined,
         serviceAgreementShow: false,
         list:[],
         signObj:{},
         zhenyunObj:{
            flag: true,
            state:'',
            channel:'',
            finishTime:''
         },
         concatDialogVisible: false,
      }
   },
 
   methods: {
      ...mapMutations('serviceAgreement', ['SET_ZHENYUN_AGREEMENT_LIST']),
      // 查询认证状态接口
      async findAuthStatus(row){
         try {
            const res = await findIsAuthentication({
               orgId: this.userInfo.orgId
            })
            if(res.rspResult.bizCode === 200){
               this.authStatus = res.data.result
               this.authCompName = res.data.compName
               this.authMobile = res.data.psnMobile
               if(!this.authStatus){
                  this.$alert(
                     '签署电子合同前，请先完成企业实名认证',
                     '请先完成企业实名认证',
                     {
                        confirmButtonText: '去完成企业实名认证',
                        customClass: 'payment-success-alert',
                        callback: (action) => {
                           if (action === 'confirm') {
                              this.$router.push({
                                 name: 'boot-page-real-name',
                                 query: {
                                    isSkip: 1,   //跳过实名认证的判断条件
                                    authCompName : this.authCompName,
                                    authMobile : this.authMobile,
                                 },
                              })
                           }
                        },
                     }
                  )
               }else{
                  // 跳转签署
                  if(row.type==140){
                    this.zhenyunObj.finishTime = row.finishTime ? handleFormatDate(row.finishTime) : ''
                    this.getZhenyunAgreementList(row.channel,true)
                     setTimeout(() => {
                      this.serviceAgreementShow = true
                     }, 500);
                     return
                  }
                  if(row.type!=140 && row.state==10 && row.method==1){
                     localStorage.setItem('signAuthMobile', this.authMobile)
                     const url = this.$router.resolve({
                        name:'boot-page-preview-contract',
                        query:{
                           type: row.type,
                           channel: row.channel
                        }
                     })
                     window.open(url.href,'_blank')
                  }else{
                     this.getAgreementAuthorization()
                  }
               }
            }else{
               this.$message.error('error',res.rspResult.message)
            }
         } catch (error) {
            console.log('error2',error)
         }
      },
      // 获取列表数据
      async getList(){
         const params={
            type:''
         }
         const res = await agreementList(params)
         if(res.rspResult.bizCode==200){
            const agreementListData = Array.isArray(res.rspListData && res.rspListData.list)
               ? res.rspListData.list
               : []
            // 智能体服务条款仅用于智能体业务，不属于生态协议库
            this.list = agreementListData.filter(item => Number(item.type) !== AGENT_AGREEMENT_TYPE)
         }else{
            this.$message.error(res.rspResult.message)
         }
      },
      //参与报名
      joinActive(){
         if(this.$store.state.userInfo.userMemberInfoVo !==null){
            // 跳转报名表单---番茄表单
            let url = 'https://ding.cjfx.cn/f/pu1kfkgk'
            window.open(url,'_target')
         }else{
            this.concatDialogVisible = true
         }
      },
      // 去签署
      goSign(row){
         this.type = row.type
         this.zhenyunObj.state = row.state
         this.zhenyunObj.channel = row.channel
         // 先判断实名认证
         this.findAuthStatus(row)
      },




     
      // 查看
      goView(row){
         this.zhenyunObj.state = row.state
         this.zhenyunObj.channel = row.channel
         this.zhenyunObj.finishTime = row.finishTime ? handleFormatDate(row.finishTime) : ''
         if(row.type==140){
            this.getZhenyunAgreementList(row.channel,true)
            //延迟调用，等待协议数据加载完成后再显示弹窗，否则会报错
            setTimeout(() => {
              this.serviceAgreementShow = true
            }, 500);
         }else{
            const url = this.$router.resolve({
               name:'boot-page-preview-contract',
               query:{
                  number: row.number,
                  state: row.state,
               }
            })
            window.open(url.href,'_blank')
         }
      },
      // 授权
      async getAgreementAuthorization(val){
         const params ={
            compId: this.userInfo.compId,
            type: this.type,
            channel: val  //甄云专区code
         }
         const res = await agreementAuthorization(params)
         if(res.rspResult.bizCode==200){
            this.$message.success('已同意授权')
            this.serviceAgreementShow = false
            this.getList()
         }

      },
    
      // 关闭授权书协议弹框
      serviceAgreementClose(channel){
         if(channel){
            this.getAgreementAuthorization(channel)
         }else{
            this.serviceAgreementShow = false
         }
      },
      // 关闭联系客户经理弹框
      closeConcatDialog(val){
         this.concatDialogVisible = val
      },
      async getContacts(){
        const res=await clientContact(0)
        if(res.rspResult.bizCode==200){
          this.salesInfoClient=res.data
        }
      },
   },
   mounted() {
      this.getContacts()
      this.getList()
      this.getZhenyunAgreementList()  //获取甄云授权书
   },
}
</script>
<style lang="scss" scoped>
.zhenyun-agreement{
   font-family: SourceHanSansCN-Regular;
   &-title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
      border: 1px solid #DCE9FF;
      // background: linear-gradient(90deg, #dce9ff80 0%, #f6f6ff80 100%);
      background: url('../../../assets/image/zhenyun/banner.png') 100%;
   }
   &-detail{
      background: #fff;
      margin: 12px;
      .detail-suggestion{
         padding: 16px;
         .head{
            display: flex; 
            align-items: flex-start;
            font-size: 14px;
            img{
               width:18px;
               height: 18px;
               margin-right: 2px;
            }
            .icon-jump{
               position: relative;
               top:2px;
            }
         }
         .tip{
            background: #F0F4FF;
            border-radius: 4px;
            padding: 16px;
            font-size: 14px;
            line-height: 20px;
            margin-top: 16px;
            .sales{
               color: #222;
               font-weight:700;
               margin-left: 22px;
               margin-top:6px;
            }
         }
        
      }
      .detail-table{
         padding: 16px;
         .status{
            display: inline-block;
            width:8px;
            height:8px;
            border-radius:50px;
            margin-right:6px;
         }
         ::v-deep .el-table{
            font-size: 14px !important;
            th.el-table__cell > .cell{
               color: #555;
            }
            td.el-table__cell {
               color:#222;
            }
         }
      }
   }
   .icon-AI{
      position: relative;
      top: 2px;
      color: transparent; 
      background-clip: text;
      background-image: linear-gradient(180deg, #2B95FF 0%, #9048F4 100%);
   }
}
</style>
<style lang="scss">
.payment-success-alert {
  padding: 30px;
}
</style>
